export function validateMinimumLength(value: string, length: number): boolean {
  return value?.length >= length;
}
